import { actions } from 'app/redux/actions/entities';

export function entities(state = { edit: {} }, action) {
  switch (action.type) {
    case actions.FETCH_ENTITY_SUCCESS_WITH_PARAMS:
      return {
        ...state,
        [action.entity]: action.result,
      };
    case actions.FETCH_ENTITY_SUCCESS:
      return {
        ...state,
        [action.entity]: Object.fromEntries(
          action.result.map((item) => [item.id, item])
        ),
      };
    case actions.PUBLISH_ENTITY_SUCCESS:
      return {
        ...state,
        [action.entity]: {
          ...state[action.entity],
          [action.entityId]: {
            ...(state[action.entity]?.[action.entityId] ?? {}),
            published: action.published,
          },
        },
      };
    case actions.GET_ENTITY_SUCCESS:
      return {
        ...state,
        [action.entity]: action.result,
      };
    default:
      return state;
  }
}
